import { render } from "./ClientMain.vue?vue&type=template&id=4861c7f8&scoped=true"
import script from "./ClientMain.vue?vue&type=script&lang=js"
export * from "./ClientMain.vue?vue&type=script&lang=js"

import "./ClientMain.vue?vue&type=style&index=0&id=4861c7f8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4861c7f8"]])

export default __exports__